import React, { Component } from 'react';
import { Avatar } from 'antd';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { dateDifferenceShorted } from '../../../utils/helpers';
import ImageApi from '../../../api/image';
import UserPlaceholder from '../../../assets/images/user_placeholder.svg';
import { connect } from 'react-redux';
import { DELETE_ORG_EVENTS_SUCCESS } from '../../../constants/actionTypes';

import CreateFeedItemEvent from '../../Feed/CreateFeedItem/CreateFeedItemEvent';
import {
  deletePostRequest,
  reportPostRequest,
  resetPostRequestSuccess,
  sendFeedbackRequest
} from '../../../actionCreators/feedActions';
import { addAlertToAlertsList } from '../../../actionCreators/globalAlerts';

import ErrorModal from '../../ErrorModal';

import {
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  Input
} from 'reactstrap';
import { logFirebaseEvent } from '../../../firebase/analytics';
import SendFeedback from "../../SendFeedback";

class EventDetailsHeader extends Component {
  constructor(props) {
    super(props);

    // Smelly duplication of modals
    this.state = {
      imageUrl: '',
      menuOpen: false,
      deleteModalOpen: false,
      editModalOpen: false,
      reportModalOpen: false,
      isErrorModalOpen: false,
      errorModalTitle: '',
      errorModalMessage: '',
      selectedReportingReason: null,
      reportPostModalOpen: false,
      reportPostDescription: '',
      reportSubmitted: false,
      showErrors: false,
      feedbackModalOpen: false,
    };
  }

  componentDidMount() {
    if (!this.props.author.image || !this.props.author.image.thumbnailUrl) return;

    ImageApi.getImage(this.props.author.image.thumbnailUrl).then((imageUrl) => {
      this.setState({ imageUrl });
    });
  }

  toggleMenu = () => {
    this.setState({ menuOpen: !this.state.menuOpen });
  };

  toggleDeleteConfirmModal = () => {
    this.setState({ deleteModalOpen: !this.state.deleteModalOpen });
  };

  toggleEditModal = () => {
    this.setState({ editModalOpen: !this.state.editModalOpen });
  };

   toggleReportModal = () => {
    this.setState({ reportModalOpen: !this.state.reportModalOpen });
  };

  toggleFeedbackModal = () => {
    this.setState({
      feedbackModalOpen: !this.state.feedbackModalOpen
    })
  }

  resetErrorModal = () => {
    this.setState({
      isErrorModalOpen: false,
      errorModalTitle: '',
      errorModalMessage: '',
    });
  };

  deleteEvent = async () => {
    logFirebaseEvent({
      event: 'delete_event',
    });

    await this.props.deletePost({ postId: this.props.postId });
    this.props.deleteEventById(this.props.eventId)

    this.setState({ deleteModalOpen: !this.state.deleteModalOpen });
    this.props.goBack();
  };

  reportPost = async () => {
    // validating
    if (!this.state.selectedReportingReason) return;

    logFirebaseEvent({
      event: 'report_post',
    });

    await this.props.reportPost({
      postId: this.props.postId,
      reason_type: this.state.selectedReportingReason,
      reason_text: this.state.reportPostDescription,
    });

    this.setState({ reportModalOpen: !this.state.reportModalOpen, reportSubmitted: true });
  };

  checkFields = (type, data) => {
    if (type === 'Event') {
      if (
        data.title.error ||
        data.description.error ||
        data.location.error ||
        data.start_time.error
      ) {
        return false;
      }
    }

    return true;
  };

  onSubmit = async (type, data) => {
    logFirebaseEvent({
      event: 'event',
      action: 'update',
    });

    if (
        data.title.error ||
        data.description.error ||
        data.location.error ||
        data.start_time.error ||
        (data.end_time && data.end_time.error)
      ) {
         return this.setState({
        ...this.state,
        showErrors: true,
      });
    }

    data.title = data.title.value;
    data.description = data.description.value;
    data.location = data.location.value;
    data.start_time = data.start_time.value;
    if (data.end_time) data.end_time = data.end_time.value;

    if (!data.image_id) {
      delete data.image_id;
    }

    this.props.updateEvent({
      eventId: this.props.eventId,
      data: data,
      cb: () => this.toggleEditModal(),
    });
  };

  render() {
    const { author, createdAt, link, currentUser } = this.props;

    return (
      <div className={`event-item-header d-flex align-items-center`}>
        <Modal isOpen={this.state.deleteModalOpen} centered>
          <ModalHeader>
            <div>Delete Event</div>
          </ModalHeader>
          <ModalBody>
            <div>Are you sure you want to delete this event? This action cannot be undone.</div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.toggleDeleteConfirmModal}>
              Cancel
            </Button>
            <div style={{ flex: 1 }} />
            <Button color="primary" onClick={() => this.deleteEvent()}>
              Delete
            </Button>
          </ModalFooter>
        </Modal>

              <Modal isOpen={this.state.reportSubmitted} centered>
                <ModalHeader
                  toggle={() => {
                    this.props.resetPostRequestSuccess();
                    this.setState({ ...this.state, reportSubmitted: false });
                  }}
                >
                  <div>Report received</div>
                </ModalHeader>
                <ModalBody>
                  <div>
                    Thank you for your report. It will be reviewed by an administrator who will take
                    appropriate action
                  </div>
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="primary"
                    className={'w-100'}
                    onClick={() => {
                      this.props.resetPostRequestSuccess();
                      this.setState({ ...this.state, reportSubmitted: false });
                    }}
                    outline
                  >
                    OKAY
                  </Button>
                </ModalFooter>
              </Modal>


        <SendFeedback isOpen={this.state.feedbackModalOpen} item={{postable_id: this.props.eventId, postable_type: 'events'}} sendFeedback={this.props.sendFeedback} toggleOpen={this.toggleFeedbackModal} />

        <Modal size="lg" style={{ maxWidth: '690px' }} isOpen={this.state.editModalOpen} centered>
          <ModalHeader toggle={this.toggleEditModal}>
            <div>Edit Event</div>
          </ModalHeader>
          <ModalBody>
            <div className="create-feed">
              <CreateFeedItemEvent
                onSubmit={this.onSubmit}
                showErrors={this.state.showErrors}
                checkFields={this.checkFields}
                addAlertToAlerts={this.props.addAlertToAlerts}
                eventId={this.props.eventId}
                // ={this.props.communityId}
              />
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={this.state.reportModalOpen} centered style={{ maxWidth: '600px', width: '100%' }}>
        <ModalHeader toggle={this.toggleReportModal}>
          <div>Report Post</div>
        </ModalHeader>
        <ModalBody>
          <UncontrolledDropdown>
            <DropdownToggle
              data-toggle="dropdown"
              outline
              style={{ width: '100%', textAlign: 'left' }}
              color={'secondary'}
            >
              <div>
                {this.state.selectedReportingReason
                  ? this.props.postReportTypes.find(
                      (postReportType) => postReportType.id === this.state.selectedReportingReason,
                    ).report_type_text
                  : 'Select reason'}
              </div>
            </DropdownToggle>
            <DropdownMenu>
              {this.props.postReportTypes &&
                this.props.postReportTypes.map((postReportType) => {
                  return (
                    <DropdownItem
                      key={postReportType.id}
                      onClick={() =>
                        this.setState({ ...this.state, selectedReportingReason: postReportType.id })
                      }
                    >
                      {postReportType.report_type_text}
                    </DropdownItem>
                  );
                })}
            </DropdownMenu>
          </UncontrolledDropdown>
          <div style={{ width: '100%', height: 20 }} />
          <Input
            type="textarea"
            name="text"
            id="description"
            placeholder={'Description (optional)'}
            maxLength={240}
            onChange={(e) => this.setState({ ...this.state, reportPostDescription: e.target.value })}
          />
        </ModalBody>
        <ModalFooter>
          <div style={{ flex: 1 }} />
          <Button className="modal-button" onClick={this.reportPost}>
            SUBMIT REPORT
          </Button>
        </ModalFooter>
      </Modal>

        <ErrorModal
          isOpen={this.state.isErrorModalOpen}
          title={this.state.errorModalTitle}
          message={this.state.errorModalMessage}
          onClose={this.resetErrorModal}
        />

        <Avatar
          shape="square"
          className="event-item-header-image"
          src={this.state.imageUrl || UserPlaceholder}
          icon="user"
          size={42}
        />

        <div className="event-item-header-content d-flex flex-column flex-fill">
          <div className="d-flex justify-content-between">
            <p className="event-item-header-text">
              <Link className="event-item-header-text" to={`/users/${author.id}`}>
                {author.first_name} {author.last_name}
              </Link>
            </p>
              <div>
                <Dropdown isOpen={this.state.menuOpen} direction="left" toggle={this.toggleMenu}>
                  <DropdownToggle
                    tag="span"
                    data-toggle="dropdown"
                    aria-expanded={this.state.menuOpen}
                  >
                    <FontAwesomeIcon
                      className="event-item-header-collapse"
                      icon={['fas', 'chevron-down']}
                    />
                  </DropdownToggle>
                  <DropdownMenu>
                    {(this.props.currentUser.userData.id === author.id) && (
                        <DropdownItem onClick={this.toggleEditModal}>Edit Event</DropdownItem>
                      )}
                    {(this.props.currentUser.userData.id === author.id) && (
                        <DropdownItem onClick={this.toggleDeleteConfirmModal}>
                          Delete Event
                        </DropdownItem> )}
                    <DropdownItem onClick={this.toggleReportModal}>Report Post</DropdownItem>
                    <DropdownItem onClick={this.toggleFeedbackModal}>Send Feedback</DropdownItem>
                    <DropdownItem onClick={this.toggleCancelConfirmModal}>Cancel</DropdownItem>
                  </DropdownMenu>
                </Dropdown>
              </div>
          </div>

          <Link to={link} className="event-item-header-time">
            {dateDifferenceShorted(createdAt)}
          </Link>
        </div>
      </div>
    );
  }
}

export default connect(
  (state, props) => ({
    currentUser: state.currentUser,
     postReportTypes: state.feed.postReportTypes,
  }),
  (dispatch) => ({
    addAlertToAlerts: (payload) => dispatch(addAlertToAlertsList(payload)),
    deletePost: (payload) => dispatch(deletePostRequest(payload)),
    reportPost: (payload) => dispatch(reportPostRequest(payload)),
    sendFeedback: (payload) => dispatch(sendFeedbackRequest(payload)),
    resetPostRequestSuccess: () => dispatch(resetPostRequestSuccess()),
    deleteEventById: payload =>
          dispatch({
            type: DELETE_ORG_EVENTS_SUCCESS,
            payload: payload,
          }),
  }),
)(EventDetailsHeader);
